module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/trapezeartist.58cb156.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/trapezeartist.jpg
// module id = tq7C
// module chunks = 0